import { render, staticRenderFns } from "./PremiumInvoiceUpdate.vue?vue&type=template&id=fb903d74"
import script from "./PremiumInvoiceUpdate.vue?vue&type=script&lang=js"
export * from "./PremiumInvoiceUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports